import React, { ReactElement } from 'react';
import { Text, StyleSheet } from 'react-native';
import Colors from '../constants/Colors';
import PressableStyled from './PressableStyled';
import Style from '../constants/Style';

interface TabButtonProps {
  select: () => void,
  selected: boolean,
  title: string,
  children?: ReactElement,
  disabled?: boolean,
}

const TabButton = ({
  select, selected, title, children, disabled,
}: TabButtonProps) => <PressableStyled
  onPress={selected ? null : select}
  style={[styles.button, selected && styles.buttonSelected]}
  {...{ disabled }}
>
    <Text style={[styles.title, selected && styles.titleSelected]}>{title}</Text>
    {children}
  </PressableStyled>;

const styles = StyleSheet.create({
  button: {
    ...Style.row,
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 3,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderColor: Colors.light.hereworksBlue300,
    marginStart: 8,
  },
  buttonSelected: {
    backgroundColor: Colors.light.hereworksBlue500,
  },
  title: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlue400,
    paddingHorizontal: 6,
  },
  titleSelected: {
    color: '#FFF',
  },
});

export default TabButton;
